<header class="headerWrapper">
  <div class="headerContainer">
    <div class="headerLeftColumn flex-1">
      <a href="javascript:void(0);" class="inline-block max-w-[140px] mr-5" [routerLink]="['/']">
        <img src="./assets/images/brand/chant.svg" alt="chant" class="block h-auto max-w-full">
      </a>
      <div class="navigation" *ngIf="showNavigation" [@slideRight]>
        <button class="closeButton" (click)="navigationToggle()">
          <i-icon name="close-circle" height="h-6" width="w-6"></i-icon>
        </button>
        <nav>
          <ul>
            <li>
              <a href="javascript:void(0);" [routerLink]="['/']" routerLinkActive="active">Home</a>
            </li>
            <li>
              <a href="javascript:void(0);" [routerLink]="['/about']" routerLinkActive="active">About</a>
            </li>
            <li>
              <a href="javascript:void(0);" (click)="toggleServiceMenu()" class="!flex !items-center !justify-between">
                <span>Services</span> 
                <i-icon [name]="'angle-down'" [height]="'h-4'" [width]="'w-4'" class="lg:hidden"></i-icon>
              </a>
              <ul class="subMenu" *ngIf="showServiceMenu">
                <li>
                  <a href="javascript:void(0);" [routerLink]="['/services/residential']" routerLinkActive="active">Residential/Home</a>
                </li>
                <li>
                  <a href="javascript:void(0);" [routerLink]="['/services/business']" routerLinkActive="active">Business/Corporate</a>
                </li>
                <li>
                  <a href="javascript:void(0);" [routerLink]="['/services/mssp']" routerLinkActive="active">Managed Service Provider</a>
                </li>
                <li>
                  <a href="javascript:void(0);" [routerLink]="['/services/cloud-backup']" routerLinkActive="active">Cloud Backup</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0);" [routerLink]="['/clients']" routerLinkActive="active">Clients</a>
            </li>
            <li>
              <a href="javascript:void(0);" [routerLink]="['/news']" routerLinkActive="active">News</a>
            </li>
            <li>
              <a href="javascript:void(0);" [routerLink]="['/contact']" routerLinkActive="active">Contact Us</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <button type="button" class="menuToggle" (click)="navigationToggle();" *ngIf="showNavToggleButton">
      <i-icon name="menu" height="h-5" width="w-5"></i-icon>
    </button>
    <span class="_callLink inline-flex gap-2 text-primary-300 font-extrabold text-xs max-sm:hidden">
      <i-icon name="phone" height="h-4" width="w-4"></i-icon>
      (902) 578-4458 OR (866) 515-4492
    </span>
    <button type="button" class="w-20 h-10 px-4 py-2.5 bg-white bg-opacity-30 rounded-3xl text-white text-sm font-bold transition-all hover:bg-primary-300" [routerLink]="['/login']">Login</button>
  </div>
</header>